/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builds_ForInputs */

const id_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk`)
};

const ms_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`untuk`)
};

const da_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`til`)
};

const de_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`für`)
};

const en_us2_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for`)
};

const es_es2_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para`)
};

const es_mx2_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para`)
};

const fil_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para sa`)
};

const fr_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pour`)
};

const it_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`per`)
};

const hu_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`-`)
};

const nl_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`voor`)
};

const no_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`for`)
};

const pl_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dla`)
};

const pt_br2_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para`)
};

const pt_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`para`)
};

const ro_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pentru`)
};

const fi_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kohteelle`)
};

const sv_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`för`)
};

const vi_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`cho`)
};

const tr_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`için`)
};

const cs_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`pro`)
};

const bg_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`за`)
};

const ru_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`для`)
};

const uk_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`для`)
};

const ar_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لـ`)
};

const hi_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`के लिए`)
};

const th_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สำหรับ`)
};

const ja_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`対象`)
};

const zh_cn2_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用于`)
};

const zh_hant1_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`用於`)
};

const ko_builds_for = /** @type {(inputs: Builds_ForInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`대상`)
};

/**
* | output |
* | --- |
* | "for" |
*
* @param {Builds_ForInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const builds_for = /** @type {((inputs?: Builds_ForInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builds_ForInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_builds_for(inputs)
	if (locale === "ms") return ms_builds_for(inputs)
	if (locale === "da") return da_builds_for(inputs)
	if (locale === "de") return de_builds_for(inputs)
	if (locale === "en-US") return en_us2_builds_for(inputs)
	if (locale === "es-ES") return es_es2_builds_for(inputs)
	if (locale === "es-MX") return es_mx2_builds_for(inputs)
	if (locale === "fil") return fil_builds_for(inputs)
	if (locale === "fr") return fr_builds_for(inputs)
	if (locale === "it") return it_builds_for(inputs)
	if (locale === "hu") return hu_builds_for(inputs)
	if (locale === "nl") return nl_builds_for(inputs)
	if (locale === "no") return no_builds_for(inputs)
	if (locale === "pl") return pl_builds_for(inputs)
	if (locale === "pt-BR") return pt_br2_builds_for(inputs)
	if (locale === "pt") return pt_builds_for(inputs)
	if (locale === "ro") return ro_builds_for(inputs)
	if (locale === "fi") return fi_builds_for(inputs)
	if (locale === "sv") return sv_builds_for(inputs)
	if (locale === "vi") return vi_builds_for(inputs)
	if (locale === "tr") return tr_builds_for(inputs)
	if (locale === "cs") return cs_builds_for(inputs)
	if (locale === "bg") return bg_builds_for(inputs)
	if (locale === "ru") return ru_builds_for(inputs)
	if (locale === "uk") return uk_builds_for(inputs)
	if (locale === "ar") return ar_builds_for(inputs)
	if (locale === "hi") return hi_builds_for(inputs)
	if (locale === "th") return th_builds_for(inputs)
	if (locale === "ja") return ja_builds_for(inputs)
	if (locale === "zh-CN") return zh_cn2_builds_for(inputs)
	if (locale === "zh-Hant") return zh_hant1_builds_for(inputs)
	return ko_builds_for(inputs)
});
export { builds_for as "builds.for" }